import React, { FC } from 'react';
import classnames from 'classnames';

import Icon from '@buyside/components/presentation/Icon/icon';

import ThumbsUpIcon from '@buyside/svgs/thumbs_up.svg';
import ScaleIcon from '@buyside/svgs/scale.svg';
import ThumbsDownIcon from '@buyside/svgs/thumbs_down.svg';
import BlockedIcon from '@buyside/svgs/blocked.svg';

import { IdeaUpdate } from '@interfaces/graphql-typings';

enum Impact {
  POSITIVE = 'positive',
  NEUTRAL = 'neutral',
  NEGATIVE = 'negative',
  CLOSED = 'closed'
}

type ImpactType = IdeaUpdate['impact'];

const castImpact = (impact: ImpactType): Impact => {
  switch (impact) {
    case 'positive':
      return Impact.POSITIVE;
    case 'neutral':
      return Impact.NEUTRAL;
    case 'negative':
      return Impact.NEGATIVE;
    default:
      return Impact.NEUTRAL;
  }
};

const impactIcons: { [key in Impact]: SVGAElement } = {
  positive: ThumbsUpIcon,
  neutral: ScaleIcon,
  negative: ThumbsDownIcon,
  closed: BlockedIcon
};

const texts = {
  positive: 'Positive Impact on Position',
  neutral: 'Neutral Impact on Position',
  negative: 'Negative Impact on Position',
  closed: 'Closed Position'
};

import styles from '@buyside/components/presentation/Feed/IdeaUpdate/ideaUpdateStyles.scss';

const IdeaUpdateImpact: FC<{ closed: boolean; impact: ImpactType }> = ({ closed, impact }) => {
  const updateImpact: Impact = closed ? Impact.CLOSED : castImpact(impact);

  const colorClasses = {
    [styles.green]: updateImpact === Impact.POSITIVE,
    [styles.blue]: updateImpact === Impact.NEUTRAL,
    [styles.red]: updateImpact === Impact.NEGATIVE || updateImpact === Impact.CLOSED
  };

  return (
    <div className={classnames(colorClasses)}>
      <Icon
        type={impactIcons[updateImpact]}
        style={classnames(styles.ideaUpdateSentimentIcon, colorClasses)}
      />
      <strong className={classnames(colorClasses)}>{texts[updateImpact]}</strong>
    </div>
  );
};

export default IdeaUpdateImpact;
